<template>
<div class="row justify-content-center col-10 pr-0" v-if="filesAdministrators.length > 0 || info.cnpj.document.length > 0">
    <div class="col-12 d-flex align-items-center mb-3">
        <h4 class="medium ndarkfour">Documentos cadastrais</h4>
    </div>
    <div class="col-12">
        <Tab class="mb-3 mt-2" v-model="activeTab" :items="tabs" />
    </div>
    <!-- <div class="col-6 d-flex justify-content-end align-items-center pr-0">
        <Button size="small" type="outline" :color="getPrimaryColor" @click="downloadAll(info.id)" v-if="filesAdministrators.length > 0 && info.cnpj.document.length > 0">
            <Download :color="getPrimaryColorHex.four" /> Baixar tudo
        </Button>
        <a :href="`/provider/${info.id}/status`" class="px-0">
            <Button size="small" type="outline" :color="getPrimaryColor" class="ml-3">
                Ver situação cadastral
            </Button>
        </a>
    </div> -->

    <div class="col-12 mt-3 pr-0" v-if="activeTab == '0' && info.cnpj">
        <div class="list-documents bdc-nmidfour mb-3" v-for="(document, index) in documentsWithoutContract" :key="index">
            <div class="col-12 d-flex flex-wrap  justify-content-between">
                <div class="col-8 d-flex align-items-center">
                    <div>
                        <File class="mr-2" />
                    </div>
                    <div>
                        <p class="c-ndarkfour mt-1 break">{{ document.originalFileName }} </p>
                    </div>
                </div>
                <div class="col-3 justify-content-end d-flex align-items-center">
                    <a :href="`${urlClient}/${document.path}`" target="_blank">
                        <Button size="small" type="outline" color="grey">
                            <Download /> Baixar
                        </Button>
                    </a>
                </div>

            </div>
        </div>
    </div>

    <div class="col-12 mt-4 pr-0" v-for="(administrator, index) in administrators" :key="index" v-else>
        <div class="mb-3">
            <h5 class="c-ndarkfour medium">
                {{ administrator.name | formatName }} <span class="c-nmidone regular"> | {{ (administrator.profession  || 'Procurador') | formatName }}</span>
            </h5>
        </div>
        <div class="list-documents bdc-nmidfour mb-3" v-for="(document, index) in administrator.document" :key="index">
            <div class="col-12 d-flex flex-wrap  justify-content-between">
                <div class="col-8 d-flex align-items-center">
                    <div>
                        <File class="mr-2" />
                    </div>
                    <div>
                        <p class="c-ndarkfour mt-1 break">{{ document.originalFileName }} </p>
                    </div>
                </div>
                <div class="col-3 justify-content-end d-flex align-items-center">
                    <a :href="`${urlClient}/${document.path}`" target="_blank">
                        <Button size="small" type="outline" color="grey">
                            <Download /> Baixar
                        </Button>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <!-- <div class="col-12 mt-5  mb-2">
        <caption class="c-nmidone">pessoa física</caption>
    </div>
    <div class="col-12 pr-0">
        <div class="list-documents bdc-nmidfour mb-3" v-for="(document) in filesAdministrators" :key="document.path">
            <div class="col-12 d-flex flex-wrap  justify-content-between">
                <div class="col-8 d-flex align-items-center">
                    <div>
                        <File class="mr-2" />
                    </div>
                    <div>
                        <p class="c-ndarkfour mt-1 break">{{ document.originalFileName }} </p>
                    </div>
                </div>
                <div class="col-3 justify-content-end d-flex align-items-center">
                    <a :href="`${urlApi}/${document.path.replace('uploads/public', 'clients/assets')}`" target="_blank">
                        <Button size="small" type="outline" color="grey">
                            <Download /> Baixar
                        </Button>
                    </a>
                </div>

            </div>
        </div>
    </div> -->
</div>
</template>

<script>
import File from '@/components/icons/File.vue';
import Download from '@/components/icons/Download.vue';
import downloadAllFilesProvider from '@/api/downloadAllFilesProvider'
import downloadArchive from '@/api/downloadArchive'

export default ({
    props: {
        info: {
            default: () =>{ return  { cnpj: { document: [] }, administrators: [] }}
        }
    },
    components: {
        File,
        Download,
    },
    data() {
        return {
            activeTab: '0',
            urlClient: process.env.VUE_APP_ROOT_API,
        }
    },
    methods: {
        async downloadAll(id) {
            const result = await downloadAllFilesProvider(id)
            await downloadArchive(`${process.env.VUE_APP_ROOT_API}/${result}`)

            this.$store.commit('user/setIsDownloadLoading', false)
        }
    },
    computed: {
        filesAdministrators: function () {
            const files = []
            this.info.administrators ?  this.info.administrators.map((administrator) => {
                administrator.document.map((documents) => {
                    files.push({
                        path: documents.path,
                        originalFileName: documents.originalFileName
                    })
                })
            }) : []
            return files
        },
          tabs(){
            const tabItems = [{ label: 'Empresa', value: '0'}]
            if(this.partners.length > 0) tabItems.push({ label: 'Sócios', value: '1'})
            if(this.procurators.length > 0) tabItems.push({ label: 'Procuradores', value: '2'})

             return tabItems
        },
        partners() {
            return this.info.administrators ? this.info.administrators.filter(administrator => (administrator.associateType == 'Sócio' && administrator.document.length)) : []
        },
        procurators() {
            return this.info.administrators ? this.info.administrators.filter(administrator => (administrator.associateType == 'Procurador' && administrator.document.length)) : []
        },
        administrators() {
            return this.activeTab == '1' ? this.partners : this.procurators
        },
        documentsWithoutContract() {
            return this.info.cnpj.document.filter((doc) => doc.docType != '0')
        }
    },
    created() {}
})
</script>

<style lang="scss" scoped>
.list-documents {
    padding: 21px;
    border: 1px solid;
    border-radius: 6px;
}
</style>
